var _rect, _rect2, _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect3, _path9, _mask, _rect4, _mask2, _rect5, _circle2, _circle3, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _circle4, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _rect16, _path41, _path42, _path43, _rect17, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _circle5, _circle6, _path58, _path59, _path60, _path61, _path62, _path63, _circle7, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustration3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 344,
    height: 292,
    viewBox: "0 0 350 284",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.5939,
    y: 18.4786,
    width: 57.8724,
    height: 44.4013,
    fill: "#FDF2D6",
    stroke: "#3C3A82",
    strokeWidth: 0.265876
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26.2013,
    y: 16.6173,
    width: 62.7468,
    height: 48.1236,
    stroke: "#3C3A82",
    strokeWidth: 0.265876
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.588 48.2656L28.8711 62.6982H86.1905L64.3049 42.252L51.2778 54.6801L46.588 48.2656Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.2873,
    cy: 35.008,
    r: 6.38103,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M298.622 137.207H291.649L319.671 282.819H321.539L298.622 137.207Z",
    fill: "#9B9B9B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M291.649 137.207H296.924L312.928 247.777L291.649 137.207Z",
    fill: "#D7D7D7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128.872 137.346H135.845L107.823 282.957H105.955L128.872 137.346Z",
    fill: "#9B9B9B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M135.845 137.346H132.358L113.084 255.618L135.845 137.346Z",
    fill: "#D7D7D7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.908 137.37C101.908 135.763 103.211 134.461 104.817 134.461H324.366C325.973 134.461 327.275 135.763 327.275 137.37C327.275 138.976 325.973 140.278 324.366 140.278H104.817C103.211 140.278 101.908 138.976 101.908 137.37Z",
    fill: "#9B9B9B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M235.461 118.779H259.891L265.813 134.461H241.383L235.461 118.779Z",
    fill: "#3C3A82"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M259.891 118.779H235.461L236.703 122.067H261.133L259.891 118.779Z",
    fill: "#02005B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 228.379,
    y: 131.68,
    width: 43.5052,
    height: 2.78231,
    fill: "#02005B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M201.898 119.791H293.559C294.44 119.791 295.154 119.077 295.154 118.196V114.304C295.154 113.423 294.44 112.709 293.559 112.709H201.898C201.017 112.709 200.303 113.423 200.303 114.304V118.196C200.303 119.077 201.017 119.791 201.898 119.791Z",
    fill: "#3C3A82"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-14-inside-1_33127_42005",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 200.303,
    y: 53.5215,
    width: 94.8514,
    height: 66.2695,
    rx: 1.59526
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 200.303,
    y: 53.5215,
    width: 94.8514,
    height: 66.2695,
    rx: 1.59526,
    stroke: "#3C3A82",
    strokeWidth: 4.78577,
    mask: "url(#path-14-inside-1_33127_42005)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-15-inside-2_33127_42005",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 211.686,
    y: 95.2559,
    width: 60.9578,
    height: 13.9115,
    rx: 0.797628
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 211.686,
    y: 95.2559,
    width: 60.9578,
    height: 13.9115,
    rx: 0.797628,
    stroke: "#D7D7D7",
    strokeWidth: 2.12701,
    mask: "url(#path-15-inside-2_33127_42005)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 216.24,
    cy: 64.1447,
    r: 4.55286,
    fill: "#D7D7D7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 219.022,
    cy: 103.098,
    r: 4.55286,
    fill: "#D7D7D7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 226.355,
    y: 60.3516,
    width: 57.1637,
    height: 7.58811,
    rx: 3.72227,
    fill: "#D7D7D7"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 249.373,
    y: 75.5273,
    width: 23.7761,
    height: 3.54112,
    rx: 1.77056,
    fill: "#D7D7D7"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 230.402,
    y: 98.5449,
    width: 36.6759,
    height: 1.77056,
    rx: 0.885279,
    fill: "#D7D7D7"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 230.402,
    y: 102.338,
    width: 36.6759,
    height: 1.77056,
    rx: 0.885279,
    fill: "#D7D7D7"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 230.402,
    y: 105.879,
    width: 36.6759,
    height: 1.77056,
    rx: 0.885279,
    fill: "#D7D7D7"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 211.686,
    y: 81.5977,
    width: 23.7761,
    height: 3.54112,
    rx: 1.77056,
    fill: "#D7D7D7"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 211.686,
    y: 75.5273,
    width: 23.7761,
    height: 3.54112,
    rx: 1.77056,
    fill: "#D7D7D7"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 249.373,
    y: 81.5977,
    width: 23.7761,
    height: 3.54112,
    rx: 1.77056,
    fill: "#D7D7D7"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 211.686,
    y: 87.668,
    width: 23.7761,
    height: 3.54112,
    rx: 1.77056,
    fill: "#D7D7D7"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 249.373,
    y: 87.668,
    width: 23.7761,
    height: 3.54112,
    rx: 1.77056,
    fill: "#D7D7D7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 247.602,
    cy: 116.25,
    r: 1.51762,
    fill: "#02005B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M191.444 198.341V192.163V164.046C191.444 148.603 162.64 148.603 131.818 148.603C130.355 135.513 128.778 105.672 121.281 103.519C91.3788 94.9312 84.7818 105.194 87.519 127.744C96.3001 200.105 105.829 198.341 114.171 198.341H191.444Z",
    fill: "#02005B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M165.225 126.465C161.342 127.358 156.472 125.886 154.522 126.051L155.917 134.142C157.493 134.205 160.969 134.258 162.264 133.961C163.882 133.589 166.713 132.938 167.708 133.561C168.703 134.184 173.871 134.713 175.895 134.334C175.136 130.287 170.079 125.349 165.225 126.465Z",
    fill: "#FDCBB4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M165.225 126.465C161.342 127.358 156.472 125.886 154.522 126.051L155.917 134.142C156.23 134.155 156.619 134.167 157.051 134.176L155.917 126.619C157.444 126.923 161.445 127.425 165.225 126.999C169.951 126.465 173.745 129.149 175.895 134.334C175.136 130.287 170.079 125.349 165.225 126.465Z",
    fill: "#F1A089"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M214.934 268.132C206.838 265.863 210.493 252.887 210.493 252.887L190.216 248.832C190.216 248.832 192.001 257.33 190.764 264.946C190.074 269.192 189.53 277.343 190.421 280.176C192.565 285.351 222.997 281.373 214.934 268.132Z",
    fill: "#FDCBB4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M190.216 248.832C190.216 248.832 192.002 257.331 190.764 264.947C190.074 269.193 189.53 277.344 190.422 280.176C190.591 280.584 190.935 280.935 191.423 281.229C190.535 277.739 190.235 269.374 191.411 267.268C192.587 265.162 191.678 261.585 192.716 262.069C195.241 263.246 203.699 261.605 209.923 261.935C210.011 258.875 210.494 252.887 210.494 252.887L190.216 248.832Z",
    fill: "#F1A089"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M238.36 276.487C233.876 275.624 222.487 270.157 214.654 268.032C211.314 270.597 211.613 275.325 210.533 277.494C209.454 279.662 208.963 281.143 199.624 281.152C190.284 281.16 191.168 280.371 190.382 280.175C189.595 279.978 189.499 282.934 190.089 282.933C190.355 282.933 198.987 283.306 208.242 282.221C220.488 283.107 233.107 282.949 235.318 282.893C239.349 282.791 241.9 277.371 238.36 276.487Z",
    fill: "#02005B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M195.998 80.5593C195.218 83.447 192.784 85.2855 191.665 85.8438C192.505 86.7162 194.629 88.9683 196.405 90.9973C197.218 87.9893 203.167 89.5685 206.363 84.0053C211.178 75.624 205.918 74.9026 203.338 76.0884C201.127 77.105 198.107 82.7435 198.51 79.6243C199.395 72.7629 196.973 76.9498 195.998 80.5593Z",
    fill: "#FDCBB4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M196.405 90.9969C197.218 87.9889 203.167 89.5681 206.363 84.0049C208.945 79.5106 208.63 77.2188 207.385 76.2426C208.776 80.0504 207.34 80.5899 206.121 83.8444C205.362 85.868 200.682 88.9031 197.267 88.9031L194.024 84.0049C193.159 84.9338 192.239 85.557 191.665 85.8434C192.505 86.7158 194.63 88.9679 196.405 90.9969Z",
    fill: "#F1A089"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M265.846 231.329C257.856 233.798 252.87 216.338 252.87 216.338L233.633 228.935C233.633 228.935 239.401 235.188 243.565 241.897C245.835 245.553 248.967 253 251.285 254.858C256.333 258.512 277.277 238.8 265.846 231.329Z",
    fill: "#FDCBB4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M233.634 228.935C233.634 228.935 239.402 235.189 243.566 241.897C245.836 245.554 248.969 253 251.286 254.858C251.729 254.784 252.181 254.688 252.639 254.571C246.918 250.863 246.972 243.773 245.035 241.539C243.586 239.867 238.006 233.897 241.311 233.359C244.617 232.82 248.377 225.992 255.494 223.015C254.659 221.126 253.06 217.203 253.06 217.203L233.634 228.935Z",
    fill: "#F1A089"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M289.298 225.69C285.097 227.474 274.297 228.618 264.98 231.508C263.633 235.493 266.51 239.242 266.819 241.639C267.129 244.036 267.237 245.359 259.489 250.57C251.742 255.782 252.037 254.636 251.275 254.912C250.513 255.187 252.077 257.688 252.566 257.359C253.056 257.03 287.046 235.021 290.335 232.69C293.624 230.359 292.728 224.449 289.298 225.69Z",
    fill: "#02005B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M161.713 101.729C141.742 83.4924 140.862 76.5366 132.389 76.4102C133.128 83.4686 135.529 100.825 141.742 114.291C147.844 120.264 161.713 127.323 169.48 121.893C175.693 117.549 192.225 100.174 197.773 92.0293L192.225 83.3418C182.24 89.6765 163.045 103.466 161.713 101.729Z",
    fill: "#CCCBEC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M192.225 83.3418L197.772 92.0293",
    stroke: "#7372B8",
    strokeWidth: 0.531752
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M141.742 114.29C143.891 116.394 147.004 118.632 150.474 120.412C147.228 110.382 140.179 89.5117 137.953 86.2741C135.727 83.0365 133.626 80.9624 132.854 80.3301C133.954 88.6975 136.481 102.889 141.742 114.29Z",
    fill: "#7372B8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M127.456 75.6512C138.712 87.0333 121.765 93.3568 112.533 73.9008L113.652 65.8666C116.135 65.6291 123.392 65.1543 127.504 65.1543C124.649 71.1675 126.314 74.5579 127.456 75.6512Z",
    fill: "#FDCBB4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M113.652 65.8666C116.135 65.6291 123.392 65.1543 127.504 65.1543C125.312 69.7703 125.784 72.8408 126.639 74.513C121.735 74.2094 115.938 68.6222 113.652 65.8666Z",
    fill: "#F1A089"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M126.677 68.9971C115.441 72.9126 109.494 60.8744 106.589 55.6688C99.7023 39.182 132.135 39.9304 132.135 43.2748C132.135 46.942 134.664 66.2136 126.677 68.9971Z",
    fill: "#FDCBB4"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M106.589 55.6688C99.7023 39.182 132.135 39.9304 132.135 43.2748C132.135 44.5159 132.424 47.5443 132.498 51.116C124.641 54.2777 117.338 49.5984 117.212 52.5071C117.085 55.4159 114.429 59.9688 113.923 59.0835C112.532 56.9335 113.038 51.3689 110.003 54.4042C106.968 57.4394 113.923 62.1187 114.05 62.8775C114.151 63.4846 114.261 65.4941 114.303 66.4229C110.624 63.2204 108.149 58.4651 106.589 55.6688Z",
    fill: "#F1A089"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3576 90.7012C98.2308 78.8709 107.349 76.2838 112.534 73.8809C129.102 93.1041 134.413 83.1131 127.457 75.6514C128.367 75.6514 130.436 75.8695 133.929 76.7458C141.116 92.0814 150.348 123.456 154.142 146.727C143.591 148.37 113.845 152.165 98.9994 152.165C98.4537 145.592 96.2661 105.489 97.3576 90.7012Z",
    fill: "#CCCBEC"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M112.533 73.8809C129.101 93.1041 134.413 83.1131 127.456 75.6514",
    stroke: "#7372B8",
    strokeWidth: 0.531752
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3576 90.7012C97.7342 85.5984 99.6447 82.2153 102.112 79.8249C106.261 77.7592 115.038 77.3208 116.961 92.0923C119.364 110.557 119.111 113.213 119.364 114.983C119.566 116.4 138.901 119.367 148.543 120.674C149.945 126.175 151.219 131.689 152.294 136.989C116.72 143.059 101.385 140.277 98.1646 138.127C97.4121 123.149 96.6047 100.902 97.3576 90.7012Z",
    fill: "#7372B8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M116.964 197.58C92.2467 190.223 93.8869 165.825 98.831 149.637C147.171 151.292 211.76 144.856 213.091 163.571C213.64 171.297 214.739 259.411 213.091 259.411C205.235 259.411 175.389 262.952 170.207 259.411C172.405 248.926 179.015 213.584 180.663 188.198C158.147 197.58 123.008 199.379 116.964 197.58Z",
    fill: "#02005B"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M138.752 149.869C176.679 149.646 212.108 149.76 213.09 163.571C213.394 167.841 213.865 196.664 213.948 221.597C207.713 201.025 197.267 162.129 191.576 157.478C185.793 152.752 162.282 150.65 138.752 149.869C125.282 149.949 111.498 150.071 98.8301 149.637C109.234 149.409 123.997 149.38 138.752 149.869Z",
    fill: "#3C3A82"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M180.663 188.197C179.646 188.621 178.604 189.029 177.539 189.423C182.092 184.162 186.948 176.549 187.657 172.906C186.948 177.459 181.728 187.745 180.345 192.509C180.465 191.045 180.572 189.606 180.663 188.197Z",
    fill: "#3C3A82"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M213.598 255.364C198.785 254.352 183.355 259.032 175.641 256.376C176.273 251.949 184.999 195.671 184.241 185.933C183.482 176.195 171.594 195.671 117.971 194.533C113.292 194.533 92.045 184.884 102.415 149.744",
    stroke: "#3C3A82",
    strokeWidth: 0.531752
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M209.608 140.659C199.484 142.426 128.026 147.515 94.8281 156.717C94.8281 156.717 188.243 139.9 196.762 161.27C205.281 182.64 219.482 234.327 223.884 244.487C232.173 241.831 244.82 227.231 256.961 218.687C227.62 159.949 222.264 138.45 209.608 140.659Z",
    fill: "#02005B",
    stroke: "#3C3A82",
    strokeWidth: 0.265876
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M255.135 215.02C246.084 220.837 232.804 236.772 225.849 238.796C218.495 221.508 209.473 184.455 199.67 165.191C198.339 162.576 196.953 160.558 195.553 158.994",
    stroke: "#3C3A82",
    strokeWidth: 0.531752
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M136.32 44.3283C135.335 34.989 127.992 35.1823 124.142 36.6078C122.042 34.104 116.628 32.3918 113.859 33.5974C107.314 36.4469 106.808 42.1911 106.82 44.6579C99.4569 52.092 106.783 59.3983 109.389 61.1273C109.694 61.5812 111.47 65.0714 113.437 67.4979C114.568 65.7428 113.773 64.4123 113.691 63.3123C113.59 61.9374 111.787 61.7088 109.589 58.4467C107.392 55.1846 110.368 52.5618 112.22 53.1695C114.073 53.7773 112.866 59.3322 114.284 58.3769C117.969 55.2764 114.811 49.3628 120.652 50.995C129.034 53.3367 136.97 50.4882 136.32 44.3283Z",
    fill: "#05185A"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M120.655 50.9967C129.036 53.3384 136.973 50.4899 136.323 44.33C135.96 40.887 134.733 38.7395 133.135 37.4718C137.35 47.2546 126.571 50.5646 120.655 50.9967Z",
    fill: "#312E63"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9413 84.0782C106.674 73.5329 112.819 80.749 114.021 84.0782C117.327 93.2369 116.226 118.073 117.327 118.073C118.209 118.073 139.598 120.175 154.015 123.33L156.545 135.092C133.744 139.205 97.6024 140.877 95.8394 134.662C93.6356 126.894 89.7746 91.8436 96.9413 84.0782Z",
    fill: "#CCCBEC"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M156.545 135.092L154.016 123.33",
    stroke: "#7372B8",
    strokeWidth: 0.531752
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 147.314,
    y: 195.553,
    width: 8.09398,
    height: 73.8576,
    fill: "#3C3A82"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M147.314 269.41H155.408L147.314 195.553V269.41Z",
    fill: "#02005B"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M147.419 269.41H155.363C157.57 271.644 163.307 273.432 169.927 274.326C176.988 275.279 182.725 275.219 182.725 282.816H118.732C118.732 275.219 122.263 275.219 132.414 274.326C140.534 273.611 145.801 270.751 147.419 269.41Z",
    fill: "#02005B"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M178.074 198.315L179.214 194.262H150.897C143.559 192.152 143.027 186.342 141.475 181.476C133.549 156.625 127.077 147.306 108.58 144.644C98.7161 143.224 91.4714 140.502 89.082 139.318C98.4217 199.913 106.553 198.339 114.433 198.339C121.126 198.339 130.01 198.315 178.074 198.315Z",
    fill: "#3C3A82"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 273.906,
    y: 50.2324,
    width: 42.4934,
    height: 32.3759,
    rx: 0.797628,
    fill: "#E5E6FF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M290.913 66.1425C293.541 63.843 291.597 61.8757 290.502 60.3701L298.874 57.5332L301.178 65.3213C298.715 69.8382 291.695 74.1504 290.913 66.1425Z",
    fill: "#FECBB5"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M290.502 60.3701L298.874 57.5332C298.389 59.35 296.327 63.3559 291.964 64.8448C292.82 63.0983 291.385 61.5841 290.502 60.3701Z",
    fill: "#FFE0A8"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M276.541 82.5687C277.198 68.443 286.377 65.6314 291.031 66.042C291.403 73.1192 298.609 69.2325 301.179 65.3223C310.048 65.3223 313.087 76.8199 313.498 82.5687H276.541Z",
    fill: "#9B9B9B"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M291.031 66.042C291.403 73.1192 298.609 69.2325 301.179 65.3223",
    stroke: "#9B9B9B",
    strokeWidth: 0.531752
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M306.718 82.5689L305.255 75.082M282.922 82.5689L284.384 75.6138",
    stroke: "#FFF7E8",
    strokeWidth: 0.265876
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M295.131 61.3117C288.106 64.6429 287.176 55.1522 287.176 49.3289C290.081 48.1974 295.36 46.9926 296.271 48.1996C300.735 46.3679 303.394 57.3934 295.131 61.3117Z",
    fill: "#FECBB5"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M287.176 49.3289C290.081 48.1974 295.36 46.9926 296.271 48.1996C299.891 46.7143 302.324 53.6831 298.709 58.4612C298.708 58.4626 298.707 58.4639 298.706 58.4652C298.707 58.4639 298.708 58.4626 298.709 58.4612C298.926 58.1611 297.811 56.7358 297.944 56.4712C298.874 55.8065 301.001 51.9513 299.938 51.6854C298.369 51.2932 298.706 54.0783 297.545 54.0783C295.817 53.9453 296.271 49.1596 294.753 49.6913C291.669 51.0739 288.438 51.2423 287.208 51.1536C287.185 50.5201 287.176 49.9065 287.176 49.3289Z",
    fill: "#FFF7E8"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M298.483 56.2079C297.957 56.7247 299.19 58.5971 299.19 58.5971C299.19 56.603 301.409 55.2736 301.732 54.4277C303.907 48.7278 299.438 49.0109 299.826 47.5069C300.603 44.4995 299.489 42.9952 297.159 42.9952C294.342 42.9952 292.629 44.4994 289.003 42.9954C283.566 40.7399 282.182 50.0797 286.673 50.5145C292.471 51.0757 294.991 47.5069 296.153 49.7627C296.927 51.2663 296.846 55.4234 298.483 52.5482C300.613 48.8068 301.288 53.4551 298.483 56.2079Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M175.093 134.459H160.254C160.952 128.895 165.84 128.894 169.506 128.895C171.951 128.895 174.395 131.677 175.093 134.459Z",
    fill: "black"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M169.508 128.895C172.353 128.895 174.396 131.677 175.094 134.459H174.012C173.6 132.221 170.797 128.2 162.883 130.02C164.782 128.895 167.355 128.895 169.508 128.895H169.508Z",
    fill: "#9B9B9B"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M190.997 113.145C197.104 114.788 196.815 118.024 195.59 119.74H195.32C197.644 115.236 192.997 114.383 190.997 113.842C188.674 113.213 186.675 111.303 191.592 110.035C199.46 108.006 196.671 104.957 190.889 103.279C186.296 101.946 177.777 101.814 174.031 101.885C175.256 101.581 179.542 101.382 186.188 101.885C198.238 102.797 200.238 108.212 195.05 109.606C189.377 111.131 187.81 112.287 190.997 113.145Z",
    fill: "#FFF7E8",
    stroke: "#FFF7E8",
    strokeWidth: 0.265876
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M199.705 119.506C199.705 119.286 199.526 119.108 199.306 119.108H187.752C187.532 119.108 187.353 119.286 187.353 119.506V131.801C187.353 133.196 188.484 134.327 189.879 134.327H197.179C198.574 134.327 199.705 133.196 199.705 131.801V119.506Z",
    fill: "#F4BD34",
    stroke: "#FDCBB4",
    strokeWidth: 0.265876
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M199.705 131.801V122.146C199.117 126.499 197.7 129.442 195.973 131.37C194.495 133.022 192.795 133.923 191.208 134.327H197.179C198.574 134.327 199.705 133.196 199.705 131.801Z",
    fill: "#FFF7E8",
    stroke: "#FDCBB4",
    strokeWidth: 0.265876
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M187.604 122.033C185.657 122.329 184.162 124.056 184.162 126.143C184.162 128.231 185.657 129.958 187.604 130.254",
    stroke: "#F4BD34",
    strokeWidth: 0.797628
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 210.187,
    cy: 20.8705,
    r: 19.2181,
    fill: "#CCCBEC"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 210.188,
    cy: 20.8713,
    r: 20.7383,
    stroke: "#02005B",
    strokeWidth: 0.265876
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M210.188 20.6659V11.1602",
    stroke: "#02005B",
    strokeWidth: 0.797628,
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M209.879 3.30664V5.99304",
    stroke: "#02005B",
    strokeWidth: 0.531752
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M192.623 20.5605L195.309 20.5605",
    stroke: "#02005B",
    strokeWidth: 0.531752
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M209.879 35.1309V37.8173",
    stroke: "#02005B",
    strokeWidth: 0.531752
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M224.445 20.5605L227.132 20.5605",
    stroke: "#02005B",
    strokeWidth: 0.531752
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M222.379 20.6641H210.393",
    stroke: "#02005B",
    strokeWidth: 0.797628,
    strokeLinecap: "round"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 210.187,
    cy: 20.8708,
    r: 2.27311,
    fill: "#02005B"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3389 156.861C16.2416 151.763 6.46264 137.233 8.12546 119.893C11.5401 125.089 21.3389 143.796 21.3389 156.861Z",
    fill: "#FFA24C"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M31.584 179.279C31.584 168.589 33.1577 146.141 39.4527 141.865C39.7496 148.695 43.9067 161.908 31.584 179.279Z",
    fill: "#FFA24C"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M41.084 193.341C40.1932 185.967 40.8464 168.102 50.5858 155.631C52.0702 159.936 56.6732 176.565 41.084 193.341Z",
    fill: "#FFA24C"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8359 205.665C46.9247 199.083 52.1903 182.801 64.5427 170.33C64.5427 175.823 60.5341 201.953 45.8359 205.665Z",
    fill: "#FFA24C"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0854 193.383C34.4045 188.336 17.4496 178.566 3.07812 179.873C9.46217 185.811 17.4793 194.423 41.0854 193.383Z",
    fill: "#FFA24C"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9861 206.003C41.0867 202.341 26.3589 195.997 6.64258 199.916C17.1837 205.113 31.1395 213.129 45.9861 206.003Z",
    fill: "#FFA24C"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M31.584 179.428C22.5276 175.915 3.73178 166.452 1 156.713C8.27484 158.198 17.4797 161.315 31.584 179.428Z",
    fill: "#FFA24C"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4038 177.201C68.3543 172.351 69.5618 161.671 74.7878 157.752C75.6783 162.206 73.8973 173.044 68.4038 177.201Z",
    fill: "#FFA24C"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M67.957 177.646C68.8973 174.776 72.6486 168.887 80.1313 168.293C77.6073 173.786 74.7865 176.31 67.957 177.646Z",
    fill: "#FFA24C"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1364 213.575V213.723C68.4026 205.112 66.9181 195.462 65.4334 191.602C61.0388 200.628 63.4043 210.011 65.1364 213.575Z",
    fill: "#FFA24C"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7324 213.575C67.613 211.892 74.3435 209.121 86.2207 211.496C83.2514 213.575 74.4919 217.732 65.7324 213.575Z",
    fill: "#FFA24C"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9263 206.004C70.6294 201.352 71.4311 190.92 77.0134 186.406C77.6074 190.712 76.8649 196.353 70.9263 206.004Z",
    fill: "#FFA24C"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6687 206.004C76.0237 204.321 86.0403 201.401 91.2663 203.183C88.1485 205.113 82.6552 209.567 71.6687 206.004Z",
    fill: "#FFA24C"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9844 196.352C82.2114 192.69 88.7439 184.92 97.058 183.139C94.3856 186.702 87.8531 194.867 79.9844 196.352Z",
    fill: "#FFA24C"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M59.793 218.475C64.3954 217.93 75.1147 217.732 81.1721 221.295C78.2028 222.631 65.2862 225.007 59.793 218.475Z",
    fill: "#FFA24C"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7933 218.475C57.2199 216.792 52.8451 210.22 55.9332 197.393C58.4575 202.44 61.8715 210.458 59.7933 218.475Z",
    fill: "#FFA24C"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1895 226.486C51.2409 209.559 59.8814 202.696 62.0193 190.225C64.0384 182.624 67.2156 178.051 68.5518 176.715",
    stroke: "#FFC6C6",
    strokeWidth: 0.531752
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5488 227.341C49.4498 217.938 45.8075 195.302 32.0298 179.98C19.4102 166.767 23.5672 157.71 19.2617 151.178",
    stroke: "#FFC6C6",
    strokeWidth: 0.531752
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8477 225.554C49.8477 222.629 63.5403 219.439 71.5213 205.368C76.5097 197.647 82.9037 193.639 85.4771 192.6",
    stroke: "#FFC6C6",
    strokeWidth: 0.531752
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9414 218.582C60.0899 218.582 74.788 221.997 81.0236 221.254",
    stroke: "#FFC6C6",
    strokeWidth: 0.265876
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8789 213.385C66.4728 213.534 78.3501 213.979 85.9218 211.455",
    stroke: "#FFC6C6",
    strokeWidth: 0.265876
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8184 205.961C77.0147 205.566 88.1496 204.447 91.119 203.141",
    stroke: "#FFC6C6",
    strokeWidth: 0.265876
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1328 196.163C82.4093 194.381 88.8923 189.304 96.6126 183.246",
    stroke: "#FFC6C6",
    strokeWidth: 0.265876
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9277 205.814C72.066 200.667 74.8175 189.602 76.7179 186.514",
    stroke: "#FFC6C6",
    strokeWidth: 0.265876
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9888 213.237C64.6424 207.199 64.2168 194.441 65.2858 191.709",
    stroke: "#FFC6C6",
    strokeWidth: 0.265876
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6438 218.285C58.2087 212.792 55.3977 200.915 55.6352 197.352",
    stroke: "#FFC6C6",
    strokeWidth: 0.265876
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9844 205.665C51.4281 197.4 62.761 178.793 64.5426 170.479",
    stroke: "#FFC6C6",
    strokeWidth: 0.265876
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0859 193.195C44.0058 187.108 49.9642 171.103 50.4393 155.781",
    stroke: "#FFC6C6",
    strokeWidth: 0.265876
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M31.584 179.089C33.3656 169.686 37.4335 149.069 39.4527 141.824",
    stroke: "#FFC6C6",
    strokeWidth: 0.265876
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3387 156.523C16.3898 146.625 6.81869 125.464 8.12519 120",
    stroke: "#FFC6C6",
    strokeWidth: 0.265876
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1386 178.942C22.5771 172.904 4.56319 160.027 1 156.82",
    stroke: "#FFC6C6",
    strokeWidth: 0.265876
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M40.937 193.046C31.9301 190.225 11.7189 183.633 2.92969 179.832",
    stroke: "#FFC6C6",
    strokeWidth: 0.265876
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8377 205.814C36.0389 205.566 14.4519 204.032 6.49414 199.875",
    stroke: "#FFC6C6",
    strokeWidth: 0.265876
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5527 176.566C70.0869 171.221 73.4521 160.027 74.6398 158.008",
    stroke: "#FFC6C6",
    strokeWidth: 0.265876
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M67.957 177.308C71.3718 174.685 78.5278 169.232 79.8343 168.4",
    stroke: "#FFC6C6",
    strokeWidth: 0.265876
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5594 224.115H27.7415C27.3802 232.107 32.116 258.262 49.5988 258.262C67.0815 258.262 71.709 234.65 72.5594 224.115Z",
    fill: "#D7D7D7"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6953 258.262C67.1043 258.262 71.7123 234.65 72.5591 224.115H67.1264C67.4819 231.502 64.4935 248.672 49.6953 258.262Z",
    fill: "#9B9B9B"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7964 282.908L73.4644 245.567M20.5977 282.908L25.9296 245.567M26.7254 239.994L27.5088 234.508H71.8853L72.6686 239.994M26.7254 239.994H72.6686M26.7254 239.994L25.9296 245.567M72.6686 239.994L73.4644 245.567M25.9296 245.567H73.4644",
    stroke: "#2F2C63",
    strokeWidth: 1.0635
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3711 282.893H349.907",
    stroke: "#232056",
    strokeWidth: 0.265876
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration3);
export default __webpack_public_path__ + "static/media/Illustration_3.8c01bdbce4219852a8692d48602d75b6.svg";
export { ForwardRef as ReactComponent };